<template>
    <div v-if="item">
        <router-link
                v-if="item"
                :to="{ name: 'PostList' }"
                class="btn btn-primary mb-4 btn-circle float-right"
                tag="button"
        >
            <font-awesome-icon icon="angle-left" size="lg"/>
        </router-link>
        <div class="discover mt-4 mb-2" v-if="!logged">
            <router-link class="btn btn-primary" :to="{name: 'AppAbout'}">{{ $t('index.discover') }}</router-link>
        </div>
        <h4>{{ item['title'] }}</h4>
        <span class="text-muted">{{ item['createDate'] | formatDate }}</span>
        <span>
      <vue-markdown>{{ item['description'] }}</vue-markdown>
    </span>
        <router-link
                v-if="item"
                :to="{ name: 'PostList' }"
                class="btn btn-primary mb-4 btn-circle"
                tag="button"
        >
            <font-awesome-icon icon="angle-left" size="lg"/>
        </router-link>
    </div>
</template>


<script>
import {mapGetters} from 'vuex';
import VueMarkdown from 'vue-markdown';

export default {
    components: {
        VueMarkdown,
    },
    computed: mapGetters({
        logged: 'user/auth/logged',
        item: 'post/show/item',
    }),
    created() {
        this.$store.dispatch(
            'post/show/retrieve',
            decodeURIComponent(this.$route.params.id),
        );
    },
    beforeDestroy() {
        this.$store.dispatch('post/show/reset');
    },
};
</script>



// WEBPACK FOOTER //
// src/components/post/Show.vue